import React from "react";
import { useTranslation } from "react-i18next";

const Success = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col p-12 justify-center text-center bg-white rounded-lg border text-pr">
      <p className="font-bold text-2xl">{t("contact.success.title")}</p>
      <p className="text-sm">{t("contact.success.desc")}</p>
    </div>
  );
};

export default Success;
